export const PendoProfilesArray = [
	{ value: 'Charter', label: 'Charter' },
	{ value: 'District', label: 'District' },
	{ value: 'Accounting', label: 'Accounting' },
	{ value: 'Nutrition', label: 'Nutrition' },
];
